export const SET_GIFT_SEARCH_VALUES = 'giftTable/SET_GIFT_SEARCH_VALUES';

export const FETCH_GIFTS_TABLES = 'giftTable/FETCH_GIFTS_TABLES';
export const FETCH_GIFTS_TABLES_SUCCESS =
  'giftTable/FETCH_GIFTS_TABLES_SUCCESS';
export const FETCH_GIFTS_TABLES_FAILED = 'giftTable/FETCH_GIFTS_TABLES_FAILED';

export const FETCH_GIFT_TABLE_INFO = 'giftTable/FETCH_GIFT_TABLE_INFO';
export const FETCH_GIFT_TABLE_INFO_SUCCESS =
  'giftTable/FETCH_GIFT_TABLE_INFO_SUCCESS';
export const FETCH_GIFT_TABLE_INFO_FAILED =
  'giftTable/FETCH_GIFT_TABLE_INFO_FAILED';
export const SET_TABLE_INFO = 'giftTable/SET_TABLE_INFO';

export const FETCH_ELECTRONIC_TABLE_INFO =
  'giftTable/FETCH_ELECTRONIC_TABLE_INFO';
export const FETCH_ELECTRONIC_TABLE_INFO_SUCCESS =
  'giftTable/FETCH_ELECTRONIC_TABLE_INFO_SUCCESS';
export const FETCH_ELECTRONIC_TABLE_INFO_FAILED =
  'giftTable/FETCH_ELECTRONIC_TABLE_INFO_FAILED';

export const FETCH_GIFT_TABLE_PRODUCTS = 'giftTable/FETCH_GIFT_TABLE_PRODUCTS';
export const FETCH_GIFT_TABLE_PRODUCTS_SUCCESS =
  'giftTable/FETCH_GIFT_TABLE_PRODUCTS_SUCCESS';
export const FETCH_GIFT_TABLE_PRODUCTS_FAILED =
  'giftTable/FETCH_GIFT_TABLE_PRODUCTS_FAILED';

export const CHANGE_GIFT_TABLE_PRODUCTS_PAGE =
  'giftTable/CHANGE_GIFT_TABLE_PRODUCTS_PAGE';
export const ADD_PRODUCT = 'giftTable/ADD_PRODUCT';
export const DELETE_PRODUCT = 'giftTable/DELETE_PRODUCT';
export const CHANGE_GIFT_TABLE_PRODUCTS_SORT =
  'giftTable/CHANGE_GIFT_TABLE_PRODUCTS_SORT';

export const DELETE_GIFT_TABLE = 'giftTable/DELETE_GIFT_TABLE';
export const DELETE_GIFT_TABLE_SUCCESS = 'giftTable/DELETE_GIFT_TABLE_SUCCESS';
export const DELETE_GIFT_TABLE_FAILED = 'giftTable/DELETE_GIFT_TABLE_FAILED';

export const UPDATE_GIFT_TABLE = 'giftTable/UPDATE_GIFT_TABLE';
export const UPDATE_GIFT_TABLE_SUCCESS = 'giftTable/UPDATE_GIFT_TABLE_SUCCESS';
export const UPDATE_GIFT_TABLE_FAILED = 'giftTable/UPDATE_GIFT_TABLE_FAILED';

export const SET_GIFT_TABLE = 'giftTable/SET_GIFT_TABLE';
export const REMOVE_GIFT_TABLE = 'giftTable/REMOVE_GIFT_TABLE';

export const REDIRECT_AND_RESET = 'giftTable/REDIRECT_AND_RESET';

export const FETCH_MY_GIFTS_TABLES = 'giftTable/FETCH_MY_GIFTS_TABLES';
export const FETCH_MY_GIFTS_TABLES_SUCCESS =
  'giftTable/FETCH_MY_GIFTS_TABLES_SUCCESS';
export const FETCH_MY_GIFTS_TABLES_FAILED =
  'giftTable/FETCH_MY_GIFTS_TABLES_FAILED';

export const FETCH_RECEIVED_GIFTS = 'giftTable/FETCH_RECEIVED_GIFTS';
export const FETCH_RECEIVED_GIFTS_SUCCESS =
  'giftTable/FETCH_RECEIVED_GIFTS_SUCCESS';
export const FETCH_RECEIVED_GIFTS_FAILED =
  'giftTable/FETCH_RECEIVED_GIFTS_FAILED';

export const FETCH_EXTERNAL_GIFT_TABLE_PRODUCTS =
  'giftTable/FETCH_EXTERNAL_GIFT_TABLE_PRODUCTS';
export const FETCH_EXTERNAL_GIFT_TABLE_PRODUCTS_SUCCESS =
  'giftTable/FETCH_EXTERNAL_GIFT_TABLE_PRODUCTS_SUCCESS';
export const FETCH_EXTERNAL_GIFT_TABLE_PRODUCTS_FAILED =
  'giftTable/FETCH_EXTERNAL_GIFT_TABLE_PRODUCTS_FAILED';

export const FETCH_SHOPPING_CART = 'gifts/FETCH_SHOPPING_CART';
export const FETCH_SHOPPING_CART_SUCCESS = 'gifts/FETCH_SHOPPING_CART_SUCCESS';
export const FETCH_SHOPPING_CART_FAILED = 'gifts/FETCH_SHOPPING_CART_FAILED';

export const UPDATE_SHOPPING_CART = 'gifts/UPDATE_SHOPPING_CART';
export const UPDATE_SHOPPING_CART_SUCCESS =
  'gifts/UPDATE_SHOPPING_CART_SUCCESS';
export const UPDATE_SHOPPING_CART_FAILED = 'gifts/UPDATE_SHOPPING_CART_FAILED';

export const ADD_SHOPPING_CART_PRODUCT = 'gifts/ADD_SHOPPING_CART_PRODUCT';
export const REMOVE_SHOPPING_CART_PRODUCT =
  'gifts/REMOVE_SHOPPING_CART_PRODUCT';

export const CREATE_SHOPPING_CART = 'gifts/CREATE_SHOPPING_CART';
export const CREATE_SHOPPING_CART_SUCCESS =
  'gifts/CREATE_SHOPPING_CART_SUCCESS';
export const CREATE_SHOPPING_CART_FAILED = 'gifts/CREATE_SHOPPING_CART_FAILED';

export const SET_TEMPORAL_PRODUCT_OF_NOT_LOGGED_USER =
  'gifts/SET_TEMPORAL_PRODUCT_OF_NOT_LOGGED_USER';
export const SET_LOGGED_AFTER_ADDING_TEMPORARY_PRODUCT =
  'gifts/SET_LOGGED_AFTER_ADDING_TEMPORARY_PRODUCT';
